module.exports = __webpack_public_path__ + "static/media/_DSC9761_Small.d3aad74b.jpg";